const resource = 'alerts'

export default $axios => ({
  get(id, params) {
    return $axios.$get(`/${resource}/${id}`, { params })
  },
  create(params) {
    return $axios.$post(`/${resource}`, params)
  },
  delete(id, params) {
    return $axios.$delete(`/${resource}/${id}`, { params })
  },

  fetchAccountAlerts() {
    return $axios.$get('/v2/account/alerts')
  },

  getServiceName: name => 'alertService',
})
